import { TooltipProvider } from "@/components/ui/tooltip";
import type { ReactNode } from "react";

/** First hover on a surface waits this long before its preview opens. */
export const PREVIEW_FIRST_DELAY_MS = 300;
/** Warm window: moving to a neighboring trigger within it opens instantly. */
export const PREVIEW_SKIP_DELAY_MS = 400;

/**
 * Chrome-tab-style hover previews for a workspace surface (tab bar, left
 * rail): the first preview is delayed — proof the user is hovering, not just
 * passing through — and while "warm", sliding across neighboring items shows
 * their previews instantly.
 *
 * The warm state (Radix `skipDelayDuration`) only spans tooltips under ONE
 * provider, and the base `Tooltip` wrapper creates an isolated provider per
 * tooltip — so preview tooltips under this component must opt in with
 * `<Tooltip grouped>`. Non-preview tooltips inside the surface are unaffected
 * (their own inner providers shadow this one).
 */
export function PreviewTooltipProvider({ children }: { children: ReactNode }) {
  return (
    <TooltipProvider
      delayDuration={PREVIEW_FIRST_DELAY_MS}
      skipDelayDuration={PREVIEW_SKIP_DELAY_MS}
    >
      {children}
    </TooltipProvider>
  );
}
